import React from "react";
import { AsSeenOnPanel, IAsSeenOnPanelProps } from "../../../components/AsSeenOnPanel";

export const getAsSeenOnPanel = ({
  title,
  logos,
  logosMobile,
  headerAnchor,
}: IAsSeenOnPanelProps) => (
  <AsSeenOnPanel
    headerAnchor={headerAnchor}
    title={title}
    logos={logos}
    logosMobile={logosMobile}
  />
);
